/* FABEL — header.js : sticky behaviour, transparent-over-hero, mega menu. */
(function () {
  'use strict';

  class StickyHeader extends HTMLElement {
    connectedCallback() {
      this.header = this.querySelector('.header');
      this.threshold = 24;
      this.lastScroll = window.scrollY;
      this.hideOnScroll = this.dataset.hideOnScroll === 'true';
      this.onScroll = this.onScroll.bind(this);
      this.onScroll();
      window.addEventListener('scroll', this.onScroll, { passive: true });
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
    }

    onScroll() {
      const y = window.scrollY;
      this.classList.toggle('is-scrolled', y > this.threshold);

      if (this.hideOnScroll && !this.classList.contains('is-menu-open')) {
        const goingDown = y > this.lastScroll && y > 240;
        this.classList.toggle('is-hidden', goingDown);
      }
      this.lastScroll = y;
    }
  }
  if (!customElements.get('sticky-header')) customElements.define('sticky-header', StickyHeader);

  /* ------------------------------------------------------------ mega menu */
  class MegaMenu extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('[data-menu-item]'));
      this.wrapper = this.closest('.header-wrapper');
      this.closeTimer = null;

      this.items.forEach((item) => {
        const trigger = item.querySelector('[data-menu-trigger]');
        const panel = item.querySelector('[data-menu-panel]');
        if (!trigger || !panel) return;

        item.addEventListener('mouseenter', () => this.openItem(item));
        item.addEventListener('mouseleave', () => this.scheduleClose());

        trigger.addEventListener('focus', () => this.openItem(item));
        trigger.addEventListener('click', (event) => {
          if (window.matchMedia('(hover: none)').matches) {
            event.preventDefault();
            item.dataset.open === 'true' ? this.closeAll() : this.openItem(item);
          }
        });
        trigger.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            this.closeAll();
            trigger.focus();
          }
        });
        panel.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            this.closeAll();
            trigger.focus();
          }
        });
      });

      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget)) this.closeAll();
      });
    }

    openItem(item) {
      window.clearTimeout(this.closeTimer);
      this.items.forEach((other) => {
        const isTarget = other === item;
        other.dataset.open = isTarget ? 'true' : 'false';
        const panel = other.querySelector('[data-menu-panel]');
        const trigger = other.querySelector('[data-menu-trigger]');
        if (panel) panel.setAttribute('data-open', isTarget ? 'true' : 'false');
        if (trigger && trigger.hasAttribute('aria-expanded')) {
          trigger.setAttribute('aria-expanded', isTarget ? 'true' : 'false');
        }
      });
      if (this.wrapper) this.wrapper.classList.add('is-menu-open');
    }

    scheduleClose() {
      window.clearTimeout(this.closeTimer);
      this.closeTimer = window.setTimeout(() => this.closeAll(), 140);
    }

    closeAll() {
      window.clearTimeout(this.closeTimer);
      this.items.forEach((item) => {
        item.dataset.open = 'false';
        const panel = item.querySelector('[data-menu-panel]');
        const trigger = item.querySelector('[data-menu-trigger]');
        if (panel) panel.setAttribute('data-open', 'false');
        if (trigger && trigger.hasAttribute('aria-expanded')) trigger.setAttribute('aria-expanded', 'false');
      });
      if (this.wrapper) this.wrapper.classList.remove('is-menu-open');
    }
  }
  if (!customElements.get('mega-menu')) customElements.define('mega-menu', MegaMenu);

  /* --------------------------------------------- announcement bar rotation */
  class AnnouncementBar extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.announcement__slide'));
      if (this.slides.length < 2) return;
      this.index = 0;
      this.interval = parseInt(this.dataset.speed || '6', 10) * 1000;

      this.querySelectorAll('[data-announcement-nav]').forEach((button) => {
        button.addEventListener('click', () => {
          this.go(button.dataset.announcementNav === 'next' ? 1 : -1);
          this.restart();
        });
      });

      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) this.restart();
    }

    restart() {
      window.clearInterval(this.timer);
      this.timer = window.setInterval(() => this.go(1), this.interval);
    }

    go(direction) {
      this.slides[this.index].classList.remove('is-active');
      this.index = (this.index + direction + this.slides.length) % this.slides.length;
      this.slides[this.index].classList.add('is-active');
    }

    disconnectedCallback() {
      window.clearInterval(this.timer);
    }
  }
  if (!customElements.get('announcement-bar')) customElements.define('announcement-bar', AnnouncementBar);

  /* ------------------------------------------- measure header for offsets */
  function setHeaderHeight() {
    const header = document.querySelector('.header');
    if (!header) return;
    document.documentElement.style.setProperty('--header-height', `${Math.round(header.offsetHeight)}px`);
  }
  window.addEventListener('resize', window.FABEL ? window.FABEL.debounce(setHeaderHeight, 150) : setHeaderHeight);
  document.addEventListener('DOMContentLoaded', setHeaderHeight);
  document.addEventListener('shopify:section:load', setHeaderHeight);
})();
